import { render, staticRenderFns } from "./MilkVatReferenceAdd.vue?vue&type=template&id=5b891ac7&"
import script from "./MilkVatReferenceAdd.vue?vue&type=script&lang=ts&"
export * from "./MilkVatReferenceAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports